import React, { useContext, useState } from "react";
import classes from "./Locations.module.scss";
import colourClasses from "../../colour.module.scss";
import GoalContext from "../../store/goal-context";
import LocationItem from "../LocationItem/LocationItem";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';


const Locations = (props) => {
  const goalContext = useContext(GoalContext);
  const [swiper, setSwiperInstance] = useState();
  let locations = null;
  let colour = 'colour--black';
  let accentColour = 'colour--black--accent';

  if (goalContext.activeGoal !== null) {
    locations = goalContext.goals[goalContext.activeGoal - 1].locations;
    colour = goalContext.goals[goalContext.activeGoal -1].primary_colour ? `colour--${goalContext.goals[goalContext.activeGoal -1].primary_colour}` : 'colour--black';
    accentColour = goalContext.goals[goalContext.activeGoal -1].secondary_colour ? `colour--${goalContext.goals[goalContext.activeGoal -1].secondary_colour}` : 'colour--black--accent';
  }

  const getSlug = ($locationPos) => {
    return goalContext.goals[goalContext.activeGoal - 1].locations[$locationPos].slug;
  };

  const scrollToTop = () => {
    const anchor = document.querySelector('#map');
    anchor.scrollIntoView({
        behavior: 'smooth',
    });
  };

  const activeLocationHandler = (payload) => {
      scrollToTop();
      const addresses = goalContext.goals[goalContext.activeGoal - 1].locations[payload.location].addresses;
      if(addresses.length > 1) {
        const bounds = new window.google.maps.LatLngBounds();
        for(let i=0; i < addresses.length; i++) {
          let point = new window.google.maps.LatLng(
            parseFloat(addresses[i].address.lat),
            parseFloat(addresses[i].address.lng)
          );
          bounds.extend(point);
        }
        goalContext.activeMapInstance.instance.fitBounds(bounds);
      } else {
        goalContext.activeMapInstance.instance.zoom = 16;
        goalContext.activeMapInstance.instance.panTo({
          lat: payload.lat,
          lng: payload.lng
        });
      }
      goalContext.setActiveLocation(payload.location);
      if (payload.location === goalContext.activeMarker) {
        return;
      }
      
      goalContext.activeSwiper.instance.slideTo(payload.location);    
      goalContext.setActiveMarker(payload.location);
      window.history.replaceState(null, '', '/goal/' + goalContext.activeGoal + '/location/' + getSlug(payload.location));
  };

  return (
    <>
      <section
        className={`${classes.locations} ${
          locations ? classes.active : classes.inactive
        }`}
      >
        {locations && (
          <>
            <div className={`${classes['desktop-header']} ${colourClasses[colour]}`}>
                <div className={classes.wrapper}>
                  <div className={`${classes['active-goal']} ${colourClasses[accentColour]}`}>{goalContext.goals[goalContext.activeGoal - 1].number}</div>
                  <div className={classes.titles}>
                    <h2>{goalContext.goals[goalContext.activeGoal - 1].short_title}</h2>
                    <h3 className={colourClasses[accentColour]}>Local Initiatives</h3>
                  </div>
                  <img className={classes['desktop-image']} src={goalContext.goals[goalContext.activeGoal - 1].goal_desktop_image} alt={goalContext.goals[goalContext.activeGoal - 1].short_title} />
                </div>
            </div>
            <div className={classes['mobile-header']}>
              <h2>Local Initiatives</h2>
            </div>
            {locations !== null && (
              <div className={classes["location-items"]}>
                <Swiper
                  onSwiper={(swiper) => goalContext.setActiveSwiper({instance: swiper})}
                  spaceBetween={32}
                  slidesPerView={1.25}
                >
                {Object.keys(locations).map((key, value) => (
                  <SwiperSlide key={value}>
                    <LocationItem
                      onClick={locations[key].addresses ? activeLocationHandler.bind("SET", {location: value, lat:locations[key].addresses[0].address.lat, lng:locations[key].addresses[0].address.lng}) : undefined}
                      key={value}
                      name={locations[key].name}
                      link={locations[key].link}
                      description={locations[key].description}
                      hasAddresses={locations[key].addresses}
                      locationID={value}
                    />
                  </SwiperSlide>
                ))}
                </Swiper>
              </div>
            )}
            {!locations && <p>No Results</p>}
          </>
        )}
      </section>
    </>
  );
};

export default Locations;
